export const DEPOSIT_METHODS = [
  {
    id: 'eur_bank',
    nameKey: 'account.payments.method.eur_bank',
    min: 10,
    max: 100000,
    icon: 'bank',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'bank',
    currency: 'EUR',
    quickAmounts: [10, 25, 50, 100, 250, 500],
  },
  {
    id: 'usd_bank',
    nameKey: 'account.payments.method.usd_bank',
    min: 10,
    max: 100000,
    icon: 'bank',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'bank',
    currency: 'USD',
    quickAmounts: [10, 25, 50, 100, 250, 500],
  },
  {
    id: 'havale',
    nameKey: 'account.payments.method.havale',
    min: 50,
    max: 100000,
    icon: 'bank',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'btq',
    quickAmounts: [50, 100, 250, 500, 1000, 2500],
  },
  {
    id: 'maxhavale',
    nameKey: 'account.payments.method.maxhavale',
    min: 50,
    max: 100000,
    icon: 'bank',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'maxhavale',
    quickAmounts: [50, 100, 250, 500, 1000, 2500],
  },
  {
    id: 'payurus',
    nameKey: 'account.payments.method.payurus',
    min: 50,
    max: 100000,
    icon: 'transfer',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'payurus',
    quickAmounts: [50, 100, 250, 500, 1000, 2500],
  },
  {
    id: 'payferrari',
    nameKey: 'account.payments.method.payferrari',
    min: 50,
    max: 100000,
    icon: 'transfer',
    imageUrl: '/payment-icons/payferrari.png',
    channel: 'payferrari',
    quickAmounts: [50, 100, 250, 500, 1000, 2500],
  },
          {
    id: 'direct_crypto',
    nameKey: 'account.payments.method.crypto',
    min: 3,
    max: 3000,
    icon: 'crypto',
    imageUrl: '/payment-icons/crypto.svg',
    channel: 'crypto',
    currency: 'USD',
    quickAmounts: [10, 25, 50, 100, 250, 500],
  },
];

export const WITHDRAW_METHODS = [
  {
    id: 'eur_bank',
    nameKey: 'account.payments.method.eur_bank',
    min: 10,
    max: 100000,
    icon: 'bank',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'bank',
    currency: 'EUR',
    quickAmounts: [10, 25, 50, 100, 250, 500],
  },
  {
    id: 'usd_bank',
    nameKey: 'account.payments.method.usd_bank',
    min: 10,
    max: 100000,
    icon: 'bank',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'bank',
    currency: 'USD',
    quickAmounts: [10, 25, 50, 100, 250, 500],
  },
  {
    id: 'havale',
    nameKey: 'account.payments.method.havale',
    min: 50,
    max: 100000,
    icon: 'bank',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'btq',
    quickAmounts: [50, 100, 250, 500, 1000, 2500],
  },
  {
    id: 'maxhavale',
    nameKey: 'account.payments.method.maxhavale',
    min: 50,
    max: 100000,
    icon: 'bank',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'maxhavale',
    quickAmounts: [50, 100, 250, 500, 1000, 2500],
  },
  {
    id: 'payurus',
    nameKey: 'account.payments.method.payurus',
    min: 50,
    max: 100000,
    icon: 'transfer',
    imageUrl: '/payment-icons/bank.svg',
    channel: 'payurus',
    quickAmounts: [50, 100, 250, 500, 1000, 2500],
  },
  {
    id: 'payferrari',
    nameKey: 'account.payments.method.payferrari',
    min: 50,
    max: 100000,
    icon: 'transfer',
    imageUrl: '/payment-icons/payferrari.png',
    channel: 'payferrari',
    quickAmounts: [50, 100, 250, 500, 1000, 2500],
  },
      {
    id: 'direct_crypto',
    nameKey: 'account.payments.method.crypto',
    min: 100,
    max: 100000,
    icon: 'crypto',
    imageUrl: '/payment-icons/crypto.svg',
    channel: 'crypto',
    currency: 'USD',
    quickAmounts: [100, 250, 500, 1000, 2500],
  },
];

export const PAYMENT_METHOD_BY_ID = Object.fromEntries(
  [...DEPOSIT_METHODS, ...WITHDRAW_METHODS].map((method) => [method.id, method]),
);

export const PAYMENT_METHOD_GROUPS = [
  {
    id: 'havale',
    nameKey: 'account.payments.group.havale',
    match: (m) => {
      const id = String(m?.id || '');
      const ch = String(m?.channel || '');
      return id === 'maxhavale'
        || id === 'havale'
        || id === 'havalespeed'
        || id === 'payurus'
        || id === 'payferrari'
        || ch === 'maxhavale'
        || ch === 'btq'
        || ch === 'havalespeed'
        || ch === 'payurus'
        || ch === 'payferrari';
    },
  },
  {
    id: 'card',
    nameKey: 'account.payments.group.card',
    match: (m) => {
      const id = String(m?.id || '');
      const ch = String(m?.channel || '');
      return m?.icon === 'card';
    },
  },
  {
    id: 'crypto',
    nameKey: 'account.payments.group.crypto',
    match: (m) => {
      const id = String(m?.id || '');
      const ch = String(m?.channel || '');
      return id === 'direct_crypto'
        || ch === 'crypto'
        || m?.icon === 'crypto';
    },
  },
  {
    id: 'other',
    nameKey: 'account.payments.group.other',
    match: () => true,
  },
];

export function groupPaymentMethods(methods = []) {
  const list = Array.isArray(methods) ? methods.filter(Boolean) : [];
  if (!list.length) return [];
  const remaining = [...list];
  const groups = [];
  for (const def of PAYMENT_METHOD_GROUPS) {
    const items = [];
    for (let i = remaining.length - 1; i >= 0; i -= 1) {
      if (def.match(remaining[i])) {
        items.unshift(remaining[i]);
        remaining.splice(i, 1);
      }
    }
    if (items.length) {
      groups.push({
        id: def.id,
        nameKey: def.nameKey,
        methods: items,
      });
    }
  }
  return groups;
}

function resolveNotice(value, tr) {
  if (!value) return null;
  if (typeof tr === 'function' && String(value).startsWith('account.')) {
    const translated = tr(value);
    return translated && translated !== value ? translated : value;
  }
  return value;
}

export function mergePaymentMethods(apiMethods = [], tr, userCurrency = null) {
  if (!apiMethods.length) {
    return { deposit: [], withdraw: [] };
  }
  const deposit = [];
  const withdraw = [];
  for (const row of apiMethods) {
    const currency = String(userCurrency || '').toUpperCase();
    if (currency && row.currencies && !String(row.currencies).toUpperCase().includes(currency)) continue;
    if (row.id === 'tt_havale' || row.channel === 'havale') continue;
    if (row.id === 'havalespeed' || row.channel === 'havalespeed') continue;
    const base = PAYMENT_METHOD_BY_ID[row.id] || {
      id: row.id,
      nameKey: row.id === 'usd_bank'
        ? 'account.payments.method.usd_bank'
        : row.id === 'eur_bank'
          ? 'account.payments.method.eur_bank'
        : row.id === 'payurus'
        ? 'account.payments.method.payurus'
        : row.id === 'payferrari'
        ? 'account.payments.method.payferrari'
        : row.id === 'maxhavale'
          ? 'account.payments.method.maxhavale'
          : row.id === 'havale'
            ? 'account.payments.method.havale'
            : 'account.payments.method.crypto',
      icon: row.icon || (row.channel === 'crypto' || String(row.id || '').includes('crypto') ? 'crypto' : 'transfer'),
      imageUrl: row.imageUrl || '/payment-icons/bank.svg',
      min: 2,
      max: 100000,
      quickAmounts: [100, 250, 500, 1000],
    };
    const shared = {
      ...base,
      icon: row.icon || base.icon,
      imageUrl: row.imageUrl || base.imageUrl,
      name: row.name || null,
      depositNotice: resolveNotice(row.depositNotice || base.depositNotice || null, tr),
      withdrawNotice: resolveNotice(row.withdrawNotice || base.withdrawNotice || null, tr),
      channel: row.channel || base.channel,
    };
    if (row.depositActive !== false) {
      deposit.push({
        ...shared,
        min: row.minDeposit ?? shared.min,
        max: row.maxDeposit ?? shared.max,
        quickAmounts: row.quickAmountsDeposit?.length ? row.quickAmountsDeposit : (shared.quickAmounts || []),
        currency: (row.channel === 'crypto' || row.id === 'direct_crypto')
          ? (row.depositCurrency || (currency === 'EUR' ? 'EUR' : 'USD'))
          : (row.depositCurrency || currency || 'TRY'),
        usdtTry: row.usdtTry ?? null,
      });
    }
    if (row.withdrawActive !== false) {
      withdraw.push({
        ...shared,
        min: row.minWithdraw ?? shared.min,
        max: row.maxWithdraw ?? shared.max,
        quickAmounts: row.quickAmountsWithdraw?.length ? row.quickAmountsWithdraw : (shared.quickAmounts || []),
        currency: row.withdrawCurrency || 'TRY',
        usdtTry: row.usdtTry ?? null,
      });
    }
  }
  return { deposit, withdraw };
}
